import { createFileRoute } from '@tanstack/react-router';
import { SearchForm } from '@features/staff';

const Index = () => {
  return (
    <>
      <SearchForm />
    </>
  );
};

export const Route = createFileRoute('/_staff/staff/')({
  component: Index,
});
